import { OPTION_ALL } from '../../../constants';
import { getWeekOptions } from '../../../tools/helpers';
import { type ReimbursementSearchFormSchema } from './ReimbursementSearchForm.hooks';

export const getDefaultReimbursementSearchFormValues = (
  data?: Partial<ReimbursementSearchFormSchema>,
): ReimbursementSearchFormSchema => {
  return {
    createdDate: OPTION_ALL,
    description: '',
    statusId: 0,
    ...data,
  };
};

/** The Week filter's choices: All, then the last 52 weeks. Shared with the phone filter. */
export const getReimbursementWeekOptions = () => {
  const weekOptions = getWeekOptions(52, 0, -1).map((week) => ({
    label: week.label,
    value: week.value.toString(),
  }));
  const allOption = { label: OPTION_ALL, value: OPTION_ALL };
  weekOptions.unshift(allOption);
  return weekOptions;
};
